/* ============================================
   HAEZEL TECH | Mobile Device Model Dropdown
   Version: 5.1
   Finds group where checkbox value = iPhone model
   v5.0: tap an identity pill and go straight to results
   v5.1: filter headings always open and close, even after
         a filter has been applied
============================================ */

(function() {
  'use strict';

  var DEVICE_VALUES = ['iphone', 'samsung', 'ipad', 'airpods'];

  function isDeviceValue(val) {
    if (!val) return false;
    var v = val.toLowerCase();
    return DEVICE_VALUES.some(function(d) { return v.indexOf(d) !== -1; });
  }

  function buildDeviceDropdown() {
    var filterForm = document.getElementById('FacetFiltersFormMobile');
    if (!filterForm) return;
    if (filterForm.querySelector('.ht-filter-dropdown-row')) return;

    var allDetails = filterForm.querySelectorAll('.mobile-facets__details');
    if (!allDetails.length) return;

    var deviceDetail = null;
    allDetails.forEach(function(detail) {
      if (deviceDetail) return;
      var firstCb = detail.querySelector('input[type="checkbox"]');
      if (firstCb && isDeviceValue(firstCb.value)) {
        deviceDetail = detail;
      }
    });

    if (!deviceDetail) return;

    var checkboxes = deviceDetail.querySelectorAll('input[type="checkbox"]');
    if (!checkboxes.length) return;

    var select = document.createElement('select');
    select.className = 'ht-filter-select';

    var defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = 'All models';
    select.appendChild(defaultOpt);

    var hasSelected = false;
    var urlParams = new URLSearchParams(window.location.search);
    var activeFilter = urlParams.get('filter.v.option.size') || '';

    checkboxes.forEach(function(cb) {
      var opt = document.createElement('option');
      opt.value = cb.value;
      opt.textContent = cb.value;
      if (activeFilter && cb.value === activeFilter) {
        opt.selected = true;
        hasSelected = true;
      }
      select.appendChild(opt);
    });

    if (!hasSelected) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === 'iPhone 18 Pro Max') {
          select.selectedIndex = i;
          select.classList.add('ht-has-value');
          break;
        }
      }
    } else {
      select.classList.add('ht-has-value');
    }

    select.addEventListener('change', function() {
      var val = this.value;
      this.classList.toggle('ht-has-value', !!val);
      var params = new URLSearchParams();
      var currentParams = new URLSearchParams(window.location.search);
      if (currentParams.get('sort_by')) {
        params.set('sort_by', currentParams.get('sort_by'));
      }
      if (val) {
        params.set('filter.v.option.size', val);
      }
      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = newUrl;
    });

    var wrapper = document.createElement('div');
    wrapper.className = 'ht-filter-dropdown-row';

    var lbl = document.createElement('span');
    lbl.className = 'ht-filter-dropdown-label';
    lbl.textContent = 'Device Model';

    wrapper.appendChild(lbl);
    wrapper.appendChild(select);

    deviceDetail.style.display = 'none';

    var insertBefore = filterForm.querySelector('.mobile-facets__details, .mobile-facets__wrapper > *');
    if (insertBefore) {
      insertBefore.parentNode.insertBefore(wrapper, insertBefore);
    } else {
      filterForm.appendChild(wrapper);
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (!node.querySelector) return;
        if (node.id === 'FacetFiltersFormMobile' ||
            node.querySelector && node.querySelector('#FacetFiltersFormMobile')) {
          setTimeout(buildDeviceDropdown, 150);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-facets__open, .facets__open, [data-target="FacetFiltersFormMobile"], .facets-container-drawer')) {
      setTimeout(buildDeviceDropdown, 300);
      setTimeout(buildDeviceDropdown, 700);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildDeviceDropdown);
  } else {
    buildDeviceDropdown();
  }

})();

/* ============================================
   IDENTITY PILLS: tap and go to results
   - Filter headings open and close reliably (one handler only)
   - Profession and Lifestyle always visible and tappable
   - One identity at a time: a new tap replaces the old one
   - Panel closes by itself once the results are ready
   - Bottom button shows the live count: "Show 14 results"
   - "Life Style" heading reads "Lifestyle"
============================================ */
(function() {
  'use strict';
  var IDENTITY = /^filter\.p\.m\.custom\.(profession|life_style)$/;
  var queued = false;

  function form() { return document.getElementById('FacetFiltersFormMobile'); }

  function countText() {
    var f = form();
    var c = f && f.querySelector('.mobile-facets__count');
    return c ? c.textContent.trim() : '';
  }

  // Filter headings: handle the tap here, before older handlers.
  // After Shopify reloads the filters, two handlers could fire and
  // open then instantly close the group, so only this one runs.
  document.addEventListener('click', function(e) {
    var s = e.target.closest && e.target.closest('#FacetFiltersFormMobile details.mobile-facets__details > summary');
    if (!s) return;
    e.preventDefault();
    e.stopPropagation();
    var d = s.parentNode;
    if (d.hasAttribute('open')) {
      d.removeAttribute('open');
      s.setAttribute('aria-expanded', 'false');
    } else {
      d.setAttribute('open', '');
      s.setAttribute('aria-expanded', 'true');
    }
  }, true);

  function closePanel() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    if (!disclosure || !disclosure.hasAttribute('open')) return;
    var summary = disclosure.querySelector(':scope > summary');
    if (summary) summary.click();
    // Safety net if the close animation is interrupted
    setTimeout(function() {
      if (disclosure.hasAttribute('open')) {
        disclosure.removeAttribute('open');
        disclosure.classList.remove('menu-opening');
        document.body.classList.remove('overflow-hidden-mobile');
      }
    }, 900);
  }

  // Close once Shopify has loaded the new results (or after 3s at most)
  function closeWhenReady(before) {
    var waited = 0;
    (function check() {
      if (countText() !== before || waited >= 3000) {
        setTimeout(closePanel, 150);
        return;
      }
      waited += 150;
      setTimeout(check, 150);
    })();
  }

  document.addEventListener('change', function(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('#FacetFiltersFormMobile input[type="checkbox"]')) return;
    if (!IDENTITY.test(t.name)) return;
    var before = countText();
    if (t.checked) {
      form().querySelectorAll('input[type="checkbox"]').forEach(function(i) {
        if (i !== t && i.checked && IDENTITY.test(i.name)) i.checked = false;
      });
    }
    closeWhenReady(before);
  }, true);

  function htTidy() {
    queued = false;
    var f = form();
    if (!f) return;

    // Identity pills stay tappable even when the other group is selected
    f.querySelectorAll('input[type="checkbox"]:disabled').forEach(function(i) {
      if (!IDENTITY.test(i.name)) return;
      i.disabled = false;
      var l = i.closest('label');
      if (l) l.classList.remove('disabled');
    });

    f.querySelectorAll('.mobile-facets__summary span, .mobile-facets__close-button span').forEach(function(s) {
      if (s.children.length === 0 && s.textContent.trim() === 'Life Style') s.textContent = 'Lifestyle';
    });

    var btn = f.querySelector('.mobile-facets__footer .button');
    var m = countText().match(/(\d+)\s+of/) || countText().match(/(\d+)/);
    if (!btn || !m) return;
    var n = parseInt(m[1], 10);
    var label = n === 0 ? 'No matches' : (n === 1 ? 'Show 1 result' : 'Show ' + n + ' results');
    if (btn.textContent.trim() !== label) btn.textContent = label;
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(htTidy, 60);
  }

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', htTidy);
  } else {
    htTidy();
  }
})();
